import * as Yup from 'yup'

import { getAdImageAssetInitialValues, getAdLandscapeLogoAssets } from '../../helpers'
import { LANDSCAPE_LOGO } from '../../../fields'
import { listOfImagesShape } from '../../../validations'

export const getInitialValues = ad => {
  const landscapeLogoAssets = getAdLandscapeLogoAssets(ad)

  return {
    [LANDSCAPE_LOGO]: landscapeLogoAssets ? landscapeLogoAssets.map(asset => getAdImageAssetInitialValues(asset)) : []
  }
}

export const validationSchema = Yup.object({
  [LANDSCAPE_LOGO]: listOfImagesShape
})
